(function ($) {
    // Smooth Scroll
    $('a[href*="#"]').not('[href="#"]').click(function(event) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {

            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top
                }, 1000);
                return false;
            }
        }
    });
})(jQuery);

(function () {
    // Form redirect
    document.addEventListener( 'DOMContentLoaded', function() {
        const observer = new MutationObserver( () => {
            const successMessage = document.querySelector( '.ets_cf_thank_msg' );

            if ( successMessage ) {
                observer.disconnect();

                setTimeout( () => {
                    window.location.href = '/pages/thank-you';
                }, 1500 );
            }
        } );

        observer.observe( document.body, {
            childList: true,
            subtree: true,
        } );
    } );
})();

(function () {
    document.addEventListener('DOMContentLoaded', () => {
        // Find all instances on the page
        const sections = document.querySelectorAll('.section-how-it-works');

        sections.forEach((section) => {
            const steps = section.querySelectorAll('.step');
            const timelineFill = section.querySelector('.timeline-fill');
            const totalSteps = steps.length;

            // Isolate state tracking per instance
            let isNextSectionVisible = false;

            // Inject structural snapping anchors into this specific section
            for (let i = 0; i < totalSteps; i++) {
                const anchor = document.createElement('div');
                anchor.className = 'scroll-snap-anchor';
                anchor.style.position = 'absolute';
                anchor.style.top = `${i * 100}vh`;
                anchor.style.height = '100vh';
                anchor.style.width = '1px';
                anchor.style.pointerEvents = 'none';
                anchor.style.scrollSnapAlign = 'top';
                anchor.style.scrollSnapStop = 'always';
                section.appendChild(anchor);
            }

            function handleScroll() {
                const rect = section.getBoundingClientRect();
                const scrollContainer = document.documentElement;

                // Toggle .is-sticky class only while this container is actively pinned
                if (rect.top <= 0 && rect.bottom > window.innerHeight) {
                    section.classList.add('is-sticky');
                } else {
                    section.classList.remove('is-sticky');
                }

                // Handle .scrolled-to-top class based on the top viewport boundary
                if (rect.top <= 0) {
                    section.classList.add('scrolled-to-top');
                } else {
                    section.classList.remove('scrolled-to-top');
                }

                // Toggle layout dynamic scroll snapping
                if (rect.top <= 0 && rect.bottom >= window.innerHeight) {
                    scrollContainer.style.scrollSnapType = 'y mandatory';
                } else {
                    scrollContainer.style.scrollSnapType = 'none';
                }

                // PAUSE: Do not process index calculations if this section's trailing neighbor is visible
                if (isNextSectionVisible) return;

                const scrolledAmount = -rect.top;
                const maxScrollable = rect.height - window.innerHeight;

                if (scrolledAmount >= 0 && scrolledAmount <= maxScrollable) {
                    const percentage = scrolledAmount / maxScrollable;
                    let activeIndex = Math.floor(percentage * totalSteps);
                    activeIndex = Math.max(0, Math.min(activeIndex, totalSteps - 1));

                    // Update step active states strictly within this instance
                    steps.forEach((step, index) => {
                        if (index <= activeIndex) {
                            step.classList.add('active');
                        } else {
                            step.classList.remove('active');
                        }
                    });

                    // Sync the progress track percentage for this instance
                    if (timelineFill) {
                        const progressWidth = (activeIndex / (totalSteps - 1)) * 100;
                        timelineFill.style.width = `${progressWidth}%`;
                    }
                }
            }

            window.addEventListener('scroll', handleScroll, { passive: true });
            handleScroll();

            // Monitor this specific section's next sibling element
            const nextSection = section.nextElementSibling;
            if (nextSection) {
                const observerOptions = {
                    root: null,
                    rootMargin: '0px 0px 300px 0px',
                    threshold: 0
                };

                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            isNextSectionVisible = true;

                            // Add the class to this exact section
                            section.classList.add('next-section-entered');

                            // Force fill state on elements strictly within this timeline loop
                            steps.forEach(step => step.classList.add('active'));
                            if (timelineFill) timelineFill.style.width = '100%';
                        } else {
                            // Only remove the class when scrolling back up and the neighbor section exits
                            if (entry.boundingClientRect.top > 0) {
                                isNextSectionVisible = false;
                                section.classList.remove('next-section-entered');

                                // Re-trigger local scroll computations instantly
                                handleScroll();
                            }
                        }
                    });
                }, observerOptions);

                observer.observe(nextSection);
            }
        });
    });
})();
